import React, { useState, useEffect } from 'react';
import { TdsField ,TdsAlert} from '@trv-tds/react';
import { set } from 'lodash';
import { ReactComponent as InfoCircle118 } from '@trv-ebus/tds-icons/dist/assets/icons/functional/svg/info-circle-1-18.svg'
import './textInput.scss'
export const TextInputWidget = ({ placeholder, label, regexMessage, columnWidth = "12",zip,setZip,setIsValidZip, validZip,setValidZip, highContrastCheck}) => {

    const appliedStyle = highContrastCheck ?  '#EF7A00':'#874600'
    const handleInput = (event) => {
        const inputValue = event.target.value;
        // Allow only digits
        const digitOnlyValue = inputValue.replace(/\D/g, '');
        event.target.value = digitOnlyValue;
        if(digitOnlyValue || digitOnlyValue ==""){
        handleChange(digitOnlyValue);
        }
    };

    const handleChange = async (inputValue) => {
        setZip(inputValue);
        
    
    }

    const textInputElem = (

        <div className='textInput' >
            <TdsField
                label={label}
                maxLength={'5'}
            >
                
                 <input
                        type={'text'}
                        value={zip}
                        placeholder={placeholder ? placeholder : ""}
                       pattern="\d*"
                       style={{color:'#000', width:'90%'}}
                       className={'zipcodeText'}
                    inputMode="numeric"
                    onInput={handleInput}
                    />
                     {(!validZip) &&
                    <div style={{ display: "flex", flexDirection: 'row' ,height: '25px', position:'absolute'}}>
                       
                        <div style={{ marginBottom:'10px', marginLeft:'5px', color: `${appliedStyle}`,fontFamily:'Batterson Sans',fontSize:'14px',fontStyle:'normal',fontWeight:'600',lineHeight:'27px'}}>
                           {regexMessage}
                        </div>
                    </div>
                   
                    }
            </TdsField>
        </div >
    );

    return (
        <>
            <div className={`tds-col-${columnWidth}`}>{textInputElem}</div>
        </>
    )
}

export default TextInputWidget;